import React, { useState } from 'react';
import { Menu } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useForm } from 'react-hook-form';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import KogCheckBoxControlled from '@main/components/shared/checkbox/checkBoxControlled';
import Button from '@/main/components/shared/button/button';
import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';

interface IDropdownButtonProps {

  trigger: React.ReactNode;
  options?: KeyValue[] | null;
  status: any | null;
  isGroup: any | null;
  disabled?: boolean;
  onClick: (option: IOption) => void;
}

export interface IOption {
  locked: boolean | null | KeyValue; // check this KeyValue
  status?: KeyValue | null;
}

const INITIAL_FORM_STATE = {
  status: null as KeyValue | null | undefined,
  locked: null as KeyValue | null,
};

type IStatusForm = typeof INITIAL_FORM_STATE;

const useStyles = makeStyles(theme => ({
  root: {
    '& .MuiPaper-root': {
      backgroundColor: '#E9E9E9'
    }
  }
}));

function DropdownButton({

  trigger,
  options,
  status,
  isGroup,
  disabled,
  onClick
}: IDropdownButtonProps) {
  const {
    handleSubmit,
    control,
    setValue,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: {
      status: isGroup ? status : status.status.id,
      locked: status.isBlocked
    }
  });
  const hasSelect = watch('locked');
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const classes = useStyles();

  options = options?.filter(option => option.key !== 3);




  const handleClick = (event: any) => {

    setAnchorEl(event.currentTarget);

  };

  const handleClose = (event: any) => {
    setAnchorEl(null);

  };

  const onSubmit = (data: IStatusForm) => {
    setAnchorEl(null);
    onClick(data);
  };

  return (
    <S.Container className="ignore-click">
      <S.ButtonTrigger type="button" onClick={handleClick} disabled={disabled}>
        {trigger}
      </S.ButtonTrigger>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
        elevation={2}
        MenuListProps={{
          'aria-labelledby': 'basic-button'
        }}
        className={`ignore-click ${classes.root} `}
        style={{ zIndex: 1 }}>
        <form onSubmit={handleSubmit(onSubmit)} noValidate>
          <div
            className="dropdown-menu-lg"
            style={{
              display: 'flex',
              flexDirection: 'column',
              paddingLeft: 10,
              paddingRight: 10
            }}>
            <KogAutoCompleteControlled
              className='ignore-click'
              label={getTranslateByKey('information.status')}
              nameCustom="status"
              valueDefaultKey={isGroup ? status : status.status.id}
              control={control}
              setValueCustom={setValue}
              options={options}
              isLoading={false}
              rulesCustom={{ required: true }}
              hasErrorCustom={!!errors.status}
              errorMessageCustom={
                errors.status?.type === 'required'
                  ? getTranslateByKey('information.statusRequired', true)
                  : ''
              }
              onChangeCustom={() => {}}
              style={{ zIndex: 2 }}
              disabled={hasSelect}
              id="id-register-txt-status"
            />
            {!isGroup && (
              <KogCheckBoxControlled
                label="Locked ?"
                nameCustom="locked"
                control={control}
                style={{ marginLeft: 5, marginTop: 5 }}
                id="id-register-txt-locked"
              />
            )}
            <Button
              style={{ maxWidth: '100%', margin: 0, marginTop: 10 }}
              type="submit"
              id="id-register-txt-save">
              {getTranslateByKey('information.save')}
            </Button>
          </div>
        </form>
      </Menu>
    </S.Container>
  );

}




export default DropdownButton;